import React from "react";
import RGL, { WidthProvider } from "react-grid-layout";
import {getLayout} from "../helper/layouts";

type Props = {
    activeTemplate: number
}

const TemplateBig = (props: Props) => {
    const ReactGridLayout = WidthProvider(RGL);
    return (
        <div className="big-template">
            {
                props.activeTemplate &&  (
                    <ReactGridLayout
                        className="layout"
                        layout={getLayout(props.activeTemplate)}
                        cols={8}
                        rowHeight={67}
                        margin={[6, 6]}
                        useCSSTransforms={false}
                    >
                        {
                            getLayout(props.activeTemplate).map(layout => (
                                <div className="panel" key={layout.i}>
                                    <span>{layout.i}</span>
                                </div>
                            ))
                        }
                    </ReactGridLayout>
                )
            }
        </div>
    )
}

export default TemplateBig;
